/**
 * Shop The Look Slider
 * Desktop slider with 4.2 slides per view
 */

if (!customElements.get('shop-the-look-slider')) {
  class ShopTheLookSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.swiperInitialized = false;
    }

    connectedCallback() {
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => this.init());
        window.addEventListener('shopify:section:select', () => this.init());
        
        setTimeout(() => {
          if (!this.swiperInitialized) this.init();
        }, 100);
      } else {
        window.addEventListener('load', () => this.init());
      }
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
    }

    init() {
      if (this.swiperInitialized) return;

      const gridEl = this.querySelector('.shop-the-look__grid');
      if (!gridEl) return;

      // Get items per view from data attributes
      const itemsDesktop = parseFloat(this.getAttribute('data-items-desktop')) || 4;
      const itemsMobile = parseFloat(this.getAttribute('data-items-mobile')) || 2;

      // Only initialize Swiper on desktop
      if (window.innerWidth < 750) {
        return;
      }

      // Add Swiper classes only on desktop
      gridEl.classList.add('swiper');
      const wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      
      // Move all items into wrapper
      const items = Array.from(gridEl.querySelectorAll('.shop-the-look__item'));
      items.forEach(item => {
        item.classList.add('swiper-slide');
        wrapper.appendChild(item);
      });
      
      gridEl.appendChild(wrapper);
      this.swiperInitialized = true;

      this.swiper = new Swiper(gridEl, {
        slidesPerView: itemsDesktop,
        spaceBetween: 4, // 0.4rem ≈ 4px
        freeMode: false,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: itemsDesktop,
            spaceBetween: 4
          },
          990: {
            slidesPerView: itemsDesktop,
            spaceBetween: 4
          },
          1200: {
            slidesPerView: itemsDesktop,
            spaceBetween: 4
          }
        }
      });

      // Reinitialize on resize
      let resizeTimeout;
      const resizeHandler = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const itemsDesktop = parseFloat(this.getAttribute('data-items-desktop')) || 4;
          
          if (window.innerWidth >= 750 && !this.swiper) {
            this.swiperInitialized = false;
            this.init();
          } else if (window.innerWidth < 750 && this.swiper) {
            // Remove Swiper classes and restore original structure
            this.swiper.destroy(true, true);
            this.swiper = null;
            this.swiperInitialized = false;
            
            const wrapper = gridEl.querySelector('.swiper-wrapper');
            if (wrapper) {
              const items = Array.from(wrapper.querySelectorAll('.shop-the-look__item'));
              items.forEach(item => {
                item.classList.remove('swiper-slide');
                gridEl.appendChild(item);
              });
              wrapper.remove();
              gridEl.classList.remove('swiper');
            }
          } else if (this.swiper && window.innerWidth >= 750) {
            // Update slidesPerView if changed
            if (this.swiper.params.slidesPerView !== itemsDesktop) {
              this.swiper.params.slidesPerView = itemsDesktop;
              this.swiper.update();
            } else {
              this.swiper.update();
            }
          }
        }, 250);
      };
      
      window.addEventListener('resize', resizeHandler);
      
      // Update on section reload (Shopify theme editor)
      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', () => {
          const itemsDesktop = parseFloat(this.getAttribute('data-items-desktop')) || 4;
          if (this.swiper && window.innerWidth >= 750) {
            this.swiper.params.slidesPerView = itemsDesktop;
            this.swiper.update();
          }
        });
      }
    }
  }

  customElements.define('shop-the-look-slider', ShopTheLookSlider);
}
